import PageHead from "@/components/PageHead";
import LegalLayout from "@/components/LegalLayout";
import privacyMd from "@/content/legal/privacy.md?raw";

export default function Privacy() {
  return (
    <>
      <PageHead
        title="Privacy Policy | WeKIT™ Career Clarity 360"
        description="How WeKIT™ collects, uses, and protects your personal data on wekit.ai — DPDP Act 2023 compliant."
        path="/privacy"
      />
      <LegalLayout markdown={privacyMd} />
    </>
  );
}
